import { useEffect, useState } from 'react'
import { Button } from 'components/ui/button'
import { Input } from 'components/ui/input'
import { Loader } from 'lucide-react'
import { saveCardinality } from 'store/cardinality/cardinalitySlice'
import { useAppDispatch, useAppSelector } from 'store/store'

export const RankingForm = () => {
  const cardinalityState = useAppSelector((state) => state.cardinality)
  const dispatch = useAppDispatch()
  const [cardinality, setCardinality] = useState<number | string>(
    cardinalityState.cardinality ?? ''
  )
  const [year, setYear] = useState<number | string>(cardinalityState.year ?? '')

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setYear(cardinalityState.year ?? '')
  }, [cardinalityState.year])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setCardinality(cardinalityState.cardinality ?? '')
  }, [cardinalityState.cardinality])

  const isValid = () => year !== '' && cardinality !== ''

  const renderContent = () => (
    <form
      className='flex flex-col gap-5'
      onSubmit={(event) => {
        // without this the browser reloads the page and can abort the save
        event.preventDefault()
        if (!isValid()) return
        dispatch(
          saveCardinality({
            year: Number(year),
            cardinality: Number(cardinality),
          })
        )
      }}
    >
      <label>Anno</label>
      <Input
        className='h-8 w-37.5 lg:w-62.5'
        type='text'
        value={year}
        onChange={(event) => setYear(event.target.value)}
      />
      <label>Cardinalità</label>
      <Input
        className='h-8 w-37.5 lg:w-62.5'
        type='text'
        value={cardinality}
        onChange={(event) => setCardinality(event.target.value)}
      />
      <div className='mt-5'>
        <Button disabled={!isValid()} type='submit'>
          Crea
        </Button>
      </div>
    </form>
  )

  const content = cardinalityState.loading ? (
    <Loader className='h-5 w-5 animate-spin' />
  ) : (
    renderContent()
  )

  return <div>{content}</div>
}

export default RankingForm
